import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'

// Plugins
import GlobalComponents from './gloablComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// router setup
import routes from './routes/routes'

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'
import i18n from './lang/lang'
import store from './store'
import axios from 'axios'
import VueTour from 'vue-tour'
import sidebarLinks from './sidebarLinks'

// import MapComponent from './components/MapComponent.vue'
// import Proj4 from 'proj4'

// enable proj4 for highmaps
import proj4 from '../src/js/proj4';
if (typeof window !== 'undefined') {
  window.proj4 = window.proj4 || proj4;
}

import Highcharts from 'highcharts'
import Highcharts3D from 'highcharts/highcharts-3d'
Highcharts3D(Highcharts)
import HighMaps from '../node_modules/highcharts/highmaps.js'
import VueHighcharts from 'vue-highcharts'
import exportingInit from 'highcharts/modules/exporting'
import loadMap from 'highcharts/modules/map'
import loadDrilldown from 'highcharts/modules/drilldown'
import 'vue-search-select/dist/VueSearchSelect.css'

exportingInit(Highcharts)
loadMap(Highcharts)
loadDrilldown(Highcharts)

Vue.use(VueHighcharts, { Highcharts })
Vue.use(HighMaps)

// Vue.component('app-map', MapComponent)

// import HighchartsVue from 'highcharts-vue'
// import exportingInit from 'highcharts/modules/exporting'
// import stockInit from 'highcharts/modules/stock'
// import mapInit from 'highcharts/modules/map'
// import addWorldMap from './js/worldmap'
// import VModal from 'vue-js-modal'

require('vue-tour/dist/vue-tour.css')

// exportingInit(Highcharts)
// stockInit(Highcharts)
// mapInit(Highcharts)
// addWorldMap(Highcharts)

// plugin setup
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate)
Vue.use(VueTour)
locale.use(lang)
// Vue.use(HighchartsVue)
// Vue.use(VModal)

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  mode: 'history' // Nickolas - remove o # da url
})

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}

/* eslint-disable no-new */
export const app = new Vue({
  el: '#app',
  store,
  i18n,
  router,
  render: h => h(App),
  template: '<App/>',
  components: { App }
})

window['vue'] = app
window.store = store



// WEBPACK FOOTER //
// ./src/main.js